
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

import './styles/PartnersList.scss'

// Swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/bundle'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

const partnersData = [
    {
        name: 'Optimacros',
        url: 'https://optimacros.com/',
        logo: 'optimacros.png',
        description: 'BI Аналитика и визуализация данных'
    },
    {
        name: 'CasPlan',
        url: 'https://casplan.kz/',
        logo: 'casplan.png',
        description: 'BI Аналитика и планирование'
    },
    {
        name: 'MaxPlanSolution',
        url: 'https://maxplansolution.com/',
        logo: 'maxplan.png',
        description: 'Наши партнёры по планированию'
    },
    {
        name: '1С Рейтинг',
        url: 'https://www.1c-rating.kz/',
        logo: 'rating.svg',
        description: 'Наш дистрибьютор 1С решений'
    },
    {
        name: 'Астор',
        url: 'https://astorsoft.kz/',
        logo: 'astor.png',
        description: 'Ведущий партнёр в автоматизации'
    },
    {
        name: 'ИЖ ТИ СИ',
        url: 'https://1c-ижтиси.рф/',
        logo: 'izh.png',
        description: 'Помощь в 1С решениях'
    },
    {
        name: '1Прогресс',
        url: 'https://1-progress.kz/',
        logo: '1progress.svg',
        description: 'Наши друзья в сфере разработки'
    },
    {
        name: 'Внедрение.KZ',
        url: 'https://vnedrenie.kz/',
        logo: 'vnedrenie.webp',
        description: 'Наши друзья в сфере внедрения'
    },
    {
        name: 'SM-UP',
        url: 'https://smup.kz/',
        // logo: 'smup.png',
        description: 'Наши друзья в сфере учёта'
    },
    {
        name: 'Арида',
        url: 'https://arida.kz/',
        // logo: 'arida.png',
        description: 'Наши друзья в сфере интеграции'
    },
    {
        name: 'Профи Софт',
        url: 'https://profi-soft.kz/',
        logo: 'profisoft.png',
        description: 'Наши друзья в разработке'
    },
    {
        name: 'ПРО системы',
        url: 'https://prosystems.kz/',
        logo: 'prosystems.svg',
        description: 'Наши друзья в системной интеграции'
    },
    {
        name: 'Entera KZ',
        url: 'https://entera.kz/',
        logo: 'entera.png',
        description: 'Распознавание и документооборот'
    },
    {
        name: 'DooDocks',
        url: 'https://doodocs.kz/',
        logo: 'doodocks.svg',
        description: 'Электронный документооборот'
    },
    {
        name: 'Клеверенс',
        url: 'https://www.cleverence.ru/',
        logo: 'cleverence.svg',
        description: 'Мобильные решения для склада и ТМЦ'
    },
    {
        name: 'Агент+',
        url: 'https://agentplus.ru/',
        logo: 'agentplus.png',
        description: 'Мобильная автоматизация торговли'
    },
    {
        name: 'Mobi С',
        url: 'https://mobi-c.kz/',
        logo: 'mobic.png',
        description: 'Мобильные решения для бизнеса'
    }
]


const PartnersList = () => {
    return (
        <div className="our-partners">
            <h2 style={{textAlign: 'center', marginBottom: '1.5rem'}}>Наши партнёры</h2>
            <div className="partners-slider">
                <Swiper
                    spaceBetween={30}
                    slidesPerView={1}
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 1000,
                        disableOnInteraction: true,
                    }}
                    loop={true}
                    breakpoints={{
                        700: {
                            slidesPerView: 3,
                        }
                    }}
                >
                    {partnersData.map((partner) => (
                        <SwiperSlide key={uuidv4()}>
                            <div className="partner-slide">
                                {partner.logo && <img
                                    src={`/images/partner-logos/${partner.logo}`}
                                    alt={partner.name}
                                    className="partner-slide__logo"
                                />}
                                <div className="partner-slide__content">
                                    {!partner.logo && <p
                                        // href={partner.url}
                                        // target="_blank"
                                        // rel="noopener noreferrer"
                                        className="partner-slide__title"
                                    >
                                        {partner.name}
                                    </p>}
                                    <p className="partner-slide__desc">{partner.description}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default PartnersList
